<template>
	<section ref="el" data-component="challenge">
		<div class="segments-wrapper">
			<svg
				class="segment-two connector-profile-desktop"
				data-segment-order="2"
				data-segment-profile="desktop"
				data-anchor-reverse="true"
				viewBox="0 0 91 201"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.750024 200.5L0.750023 181.337C0.750022 164.147 0.750022 155.552 2.96143 147.634C4.92035 140.619 8.13982 134.021 12.4624 128.16C17.3421 121.543 24.1163 116.253 37.6647 105.673L52.8353 93.8266C66.3837 83.2467 73.1579 77.9567 78.0376 71.3404C82.3602 65.4795 85.5797 58.8806 87.5386 51.8665C89.75 43.9483 89.75 35.3533 89.75 18.1634L89.75 0"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<svg class="segment-three connector-profile-desktop" data-segment-order="3" data-segment-profile="desktop" viewBox="0 0 91 201" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.750024 -3.89031e-06L0.750023 19.1634C0.750022 36.3533 0.750022 44.9483 2.96143 52.8665C4.92035 59.8806 8.13982 66.4795 12.4624 72.3404C17.3421 78.9567 24.1163 84.2467 37.6647 94.8266L52.8353 106.673C66.3837 117.253 73.1579 122.543 78.0376 129.16C82.3602 135.021 85.5797 141.619 87.5386 148.634C89.75 156.552 89.75 165.147 89.75 182.337L89.75 200.5"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<!--  -->
			<svg
				class="segment-two connector-profile-mobile"
				data-segment-order="2"
				data-segment-profile="mobile"
				width="96"
				height="95"
				viewBox="0 0 96 95"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M94.8118 0L94.8118 18.6566C94.8118 45.6232 72.9511 67.4839 45.9845 67.4839C31.5214 67.4839 17.8026 73.8958 8.52542 84.9915L0.575398 94.5"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<svg
				class="segment-three connector-profile-mobile"
				data-segment-order="3"
				data-segment-profile="mobile"
				data-anchor-reverse="true"
				width="60"
				height="29"
				viewBox="0 0 60 29"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1.20545e-06 28.0586C12.4962 28.0586 18.7442 28.0586 24.4916 26.6806C31.0583 25.1062 37.2381 22.2179 42.6581 18.19C47.4018 14.6646 51.3547 9.93677 59.2606 0.481079"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<svg
				class="segment-four connector-profile-mobile"
				data-segment-order="4"
				data-segment-profile="mobile"
				data-anchor-reverse="true"
				width="59"
				height="73"
				viewBox="0 0 59 73"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.750003 72.6725L0.750003 58.7499C0.750002 51.3195 0.750002 47.6043 1.14425 44.4834C4.00496 21.8382 21.8382 4.00496 44.4834 1.14425C47.6043 0.75 51.3195 0.75 58.7499 0.75"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<svg
				class="segment-five connector-profile-mobile"
				data-segment-order="5"
				data-segment-profile="mobile"
				width="41"
				height="90"
				viewBox="0 0 41 90"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.750015 1.70474e-06L0.750016 8.46141C0.750016 23.4751 8.01593 37.5605 20.25 46.2633C32.4841 54.9661 39.75 69.052 39.75 84.0657C39.75 86.1143 39.75 88.0918 39.75 90"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
			<svg
				class="segment-six connector-profile-mobile"
				data-segment-order="6"
				data-segment-profile="mobile"
				width="41"
				height="103"
				viewBox="0 0 41 103"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M39.75 0C39.75 1.66647 39.75 3.37173 39.75 5.11649C39.75 7.03884 39.75 8.00001 39.7162 8.91813C39.2181 22.4675 33.2388 35.2337 23.1487 44.2905C22.465 44.9042 21.7267 45.5195 20.25 46.75C18.7733 47.9806 18.035 48.5959 17.3513 49.2096C7.2612 58.2663 1.28184 71.0325 0.783736 84.5819C0.749984 85.5 0.749984 86.4611 0.749984 88.3833L0.749982 103"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>
		</div>
		<div class="g-row">
			<div class="g-col xxl-2 md-3 sm-4 xs-6 xs-offset-1 side-tagline">
				<p class="-body-medium">{{ sideTagline }}</p>
			</div>
			<div class="g-col xxl-8 xxl-offset-6 md-offset-5 sm-16 sm-offset-0 xs-offset-1 xs-15 title-wrapper">
				<h3 class="-title-4 title">
					<SanityContent :value="title" :components="components" />
				</h3>

				<p class="-body-big-regular description">
					<SanityContent :value="description" :components="components" />
				</p>
			</div>
		</div>
	</section>
</template>

<script setup>
import { h } from 'vue'

defineProps({
	title: { type: Array, default: undefined },
	description: { type: Array, default: undefined },
	sideTagline: { type: String, default: undefined },
})

const components = {
	block: {
		normal: (_, { slots }) => h('span', { class: 'title-line' }, slots.default?.()),
	},
}

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
onMounted(() => {
	const loader = context?.$page?.loader

	loader.loaded.then(() => setup())
	loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='challenge'] {
	position: relative;

	margin-top: rs(100, 50);
	padding-top: rs(100, 50);

	@include max-width($xs) {
		padding-bottom: rs(100, 80);
	}

	.segments-wrapper {
		position: absolute;
		inset: 0;
		pointer-events: none;
		overflow: visible;

		.segment-two {
			position: absolute;
			left: calc(column-width(7, true) + #{rs(91)} * 0.5 + var(--grid-half-gap));
			width: rs(91);
			height: auto;

			@include min-width(2101px) {
				left: 45.6vw !important;
			}
			@include max-width($sm) {
				left: initial;
				right: calc(column-width(2, true) - var(--grid-gap) - var(--grid-half-gap));
				width: rs(96, 96);
			}
		}

		.segment-three {
			position: absolute;
			left: calc(column-width(7, true) + #{rs(91)} * 0.5 + var(--grid-half-gap));
			bottom: rs(100);
			width: rs(91);
			height: auto;

			@include min-width(2101px) {
				left: 45.6vw !important;
			}

			@include max-width($sm) {
				left: column-width(6, true);
				bottom: initial;
				top: rs(180, 180);
				width: rs(59, 59);
			}
		}
		.segment-four {
			@include max-width($sm) {
				position: absolute;
				left: calc(column-width(1) - var(--grid-gap) - var(--grid-half-gap));
				top: rs(207, 207);
				width: rs(72, 72);
				height: auto;
			}
		}
		.segment-five {
			@include max-width($sm) {
				position: absolute;
				left: calc(column-width(1) - var(--grid-gap) - var(--grid-half-gap));
				bottom: rs(150, 150);
				width: rs(49, 49);
				height: auto;
			}
		}
		.segment-six {
			@include max-width($sm) {
				position: absolute;
				left: calc(column-width(1) - var(--grid-gap) - var(--grid-half-gap));
				bottom: 0;
				width: rs(49, 49);
				height: auto;
			}
		}

		.connector-profile-desktop {
			display: block;
			visibility: visible;
		}

		.connector-profile-mobile {
			display: none;
			visibility: hidden;
		}

		@media (max-width: 743px) {
			.connector-profile-desktop {
				display: none;
				visibility: hidden;
			}

			.connector-profile-mobile {
				display: block;
				visibility: visible;
			}
		}

		@media (min-width: 744px) and (max-width: 1000px) {
			.connector-profile-desktop,
			.connector-profile-mobile {
				display: none;
				visibility: hidden;
			}
		}
	}

	.side-tagline {
		@include max-width($sm) {
			margin-bottom: rs(86, 100);
		}

		p {
			position: relative;
			padding-left: rs(20, 18);

			color: var(--color-neutral-tints-700);

			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;

				width: 1.5px;
				height: 100%;
				background-color: var(--color-river-blue-500);
			}
		}
	}

	.title {
		white-space: pre-line;

		& :deep(.title-line) {
			display: block;
			@include inherit-font;

			color: var(--color-neutral-tints-900);

			&:first-child {
				text-indent: column-width(2, true);

				@include max-width($sm) {
					text-indent: column-width(4, true);
				}
			}
		}

		& :deep(strong) {
			color: var(--color-river-blue-500);
			@include inherit-font;
		}
	}

	.description {
		position: relative;

		margin-top: rs(130, 80);
		margin-left: column-width(2, true);

		width: column-width(3);

		@include max-width($md) {
			width: column-width(4);

			margin-left: column-width(2, true);
		}

		@include max-width($sm) {
			width: column-width(11);

			margin-left: column-width(3, true);
		}

		& :deep(.title-line) {
			display: block;
			@include inherit-font;

			color: var(--color-neutral-tints-700);
		}

		& :deep(strong) {
			color: var(--color-river-blue-500);
			@include inherit-font;
		}
	}
}
</style>
